export default "__VITE_ASSET__G5CWTo$C__"